import React, { PureComponent, Fragment } from 'react'
import { Route } from 'react-router-dom'

// local components
import POSettings from './POSettings'
import ResetShopSettings from './ResetShopSettings'
import ManageReceipts from './ManageReceipts'
import InventoryManagement from './InventoryManagement'
import ShopDocuments from './ShopDocuments'
import ShopTerminals from './ShopTerminals'
import ShopContracts from './ShopContracts'
import OnlineStore from './OnlineStore'
import ShopInfo from './ShopInfo'
import TaxOption from './TaxOption'
import FeeMinimums from './FeeMinimums'
import PricingTemplate from './PricingTemplate'
import PaymentOptions from './PaymentOptions'
import PaymentOptionsV2 from './PaymentOptionsV2'
import FeeOptions from './FeeOptions'
import PaymentProviders from './PaymentProviders'
import Notifications from './Notifications'
import DeliveryTax from './DeliveryTax'
import InvoicesAndPurchaseOrders from './InvoicesAndPurchaseOrders'
import Adjustments from './Adjustments'
import ManageDejavoo from '../Dejavoo'

import ShopSettingsWithUpdate from '../../../components/layout/ShopSettingsWithUpdate'
import Limits from './Limits'

class ShopPage extends PureComponent {
  render() {
    const { match, shop } = this.props

    return (
      <Fragment>
        <h2 style={{ textTransform: 'capitalize' }}>{shop.name}</h2>
        <Route exact path={`${match.url}/`} component={ShopInfo} />
        <Route exact path={`${match.url}/posetting/`} component={POSettings} />
        <Route exact path={`${match.url}/reset/`} component={ResetShopSettings} />
        <Route exact path={`${match.url}/receipts/`} component={ManageReceipts} />
        <Route exact path={`${match.url}/inventory/`} component={InventoryManagement} />
        <Route exact path={`${match.url}/documents/`} component={ShopDocuments} />
        <Route exact path={`${match.url}/terminals/`} component={ShopTerminals} />
        <Route exact path={`${match.url}/contracts/`} component={ShopContracts} />
        <Route exact path={`${match.url}/onlinestore/`} component={OnlineStore} />
        <Route exact path={`${match.url}/taxoption/`} component={TaxOption} />
        <Route exact path={`${match.url}/deliverytax/`} component={DeliveryTax} />
        <Route exact path={`${match.url}/feeminimums/`} component={FeeMinimums} />
        <Route exact path={`${match.url}/fees/`} component={FeeOptions} />
        <Route exact path={`${match.url}/pricingtemplate/`} component={PricingTemplate} />
        <Route path={`${match.url}/blazePay/`} component={ManageDejavoo} />
        <Route exact path={`${match.url}/paymentoptions/`} component={PaymentOptions} />
        <Route path={`${match.url}/newpaymentoptions/`} component={PaymentOptionsV2} />
        <Route exact path={`${match.url}/paymentproviders/`} component={PaymentProviders} />
        <Route exact path={`${match.url}/notifications/`} component={Notifications} />
        <Route exact path={`${match.url}/invoices/`} component={InvoicesAndPurchaseOrders} />
        <Route exact path={`${match.url}/adjustments/`} component={Adjustments} />
        <Route exact path={`${match.url}/limits`} component={Limits} />
      </Fragment>
    )
  }
}

export default ShopSettingsWithUpdate(ShopPage)



// WEBPACK FOOTER //
// ./src/containers/Settings/Shop/ShopPage.js